<template>
  <BaseField v-bind="$attrs" v-model="inputVal" :baseRule="baseRule" veeMode="onKeyUp" :veeDebounce="800">
    <template v-slot:afterInput="slotProps">
      <span v-show="slotProps.valid && showGreenCircle">
        <img src="@/assets/images/Ellipse 644.png" class="img-inline" alt width="25.3" height="25.3" />
        <span class="body-td-explain">このIDを使用可能です</span>
      </span>
    </template>
  </BaseField>
</template>

<script>
import BaseField from '@/components/forms/BaseField.vue';

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    showGreenCircle: {
      type: Boolean,
      default: true,
    },
    resourceType: String,
  },
  components: {
    BaseField,
  },
  computed: {
    baseRule() {
      return ['alphanumeric_hyphen_underbar', this.resourceType + '_id_unique'].join('|');
    },
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style scoped>
.img-inline {
  margin-left: 5px;
}

.body-td-explain {
  margin-left: 5px;
  font-size: 10px;
}
</style>
